import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import TrainingPortal from '../components/TrainingPortal';

const TrainingPage = ({ user, setUser }) => {
  const token = localStorage.getItem('token');

  return (
    <div className="min-h-screen bg-gray-50" data-testid="training-page">
      <Header user={user} setUser={setUser} />
      <Navigation user={user} />
      
      <main className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Training Portal</h1>
          <p className="text-gray-600">Complete your assigned trainings and earn certificates</p>
        </div>
        
        <TrainingPortal token={token} user={user} />
      </main>
    </div>
  );
};

export default TrainingPage;
